module.exports = __webpack_public_path__ + "static/img/n_1_6.22d13ea7.png";